import register from 'ShopUiBundle/modules/app/registry';
import './rating-stars.scss';

// tslint:disable-next-line
register('rating-stars', () => import(/* webpackMode: "lazy" */'./rating-stars'));
